import { useMutation, useQueryClient } from "@tanstack/vue-query";
import CallLog from "@/services/call-log";

export function useDeleteCallLog() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      const result = await CallLog.deleteCallLog(id);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete call log");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["callLogs"] });
    },
  });
}
